import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

// Internal-CRM ticket submission from the medical / lab partner portals.
// Single mutation for now — the create endpoint. Listing the user's
// own tickets in a "My Tickets" view is a v2 concern; admins are the
// primary audience for these tickets right now.

export const portalTicketsApi = createApi({
  reducerPath: 'portalTicketsApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['PortalTicket'],
  endpoints: (builder) => ({
    // POST /api/portal/tickets — multipart. Body is FormData with
    // text fields + optional files (field name "files").
    createPortalTicket: builder.mutation({
      query: (formData) => ({
        url: '/portal/tickets',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['PortalTicket'],
    }),
  }),
});

export const { useCreatePortalTicketMutation } = portalTicketsApi;
